module.exports = __webpack_public_path__ + "img/1.dac53779.png";